/**
 * Normalize an axios error from the ms-agents backend into a plain `Error`
 * that still carries the HTTP status.
 *
 * The comms services used to collapse failures into `new Error(message)`,
 * which threw away `response.status`. Callers that needed to distinguish a
 * moderation rejection (422) from a generic failure were forced to sniff the
 * message text for substrings like "policy" or "422" — fragile, and wrong as
 * soon as the backend rewords a message. Keeping `status` on the error lets
 * callers branch on the real thing.
 *
 * @param {any} err - The caught error (typically an axios error).
 * @param {string} fallbackMessage - Used when the response carries no message.
 * @returns {Error} An error with `status`, `data` and `cause` attached.
 */
export const wrapCommsError = (err, fallbackMessage) => {
  // FastAPI puts the human message in `detail`, but a 422 makes it an array of
  // validation objects — only trust it when it's a plain string.
  const detail = err?.response?.data?.detail;
  const message =
    (typeof detail === "string" && detail) ||
    err?.response?.data?.message ||
    fallbackMessage;
  console.error(message);

  const error = new Error(message);
  error.status = err?.response?.status;
  error.data = err?.response?.data;
  error.cause = err;
  return error;
};
